import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Spinner from './Spinner';

function Button({ label, onClick, className, style, withLoading = false }) {
  const [isLoading, setLoading] = useState(false);
  const clickEvent = (e) => {
    onClick(e);
    if (withLoading) {
      setLoading(true);
      setTimeout(() => { setLoading(false); }, 1000);
    }
  }

  return (withLoading && isLoading)
    ? <Spinner className={`spinner-button`} />
    : (
      <div className={`bp-button ${className}`} onClick={clickEvent} style={{ ...style }} >
        {label}
      </div>
    )
}

Button.propTypes = {
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  style: PropTypes.object,
  withLoading: PropTypes.bool,
}

export default Button;
